import { prefixerT } from './common'

export const ROUTE_GESTION_ORDEN_TRABAJO = prefixerT('gestion-orden-trabajo')

export const ROUTE_CREAR_ORDEN_TRABAJO = prefixerT('crear-orden-trabajo')

export const ROUTE_ORDEN_TRABAJO = prefixerT('orden-trabajo')

export const ROUTE_PARAMETRIZACION_PLANES_MANTENIMIENTO = prefixerT('parametrizacion-planes-mantenimiento')
